import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom'

import AppShell from './layout/AppShell'
import BoardDrawer from './layout/BoardDrawer'
import { AuthProvider, useAuth } from './auth/AuthContext'
import { BoardPageWithBoundary } from './pages/BoardPage'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import SettingsPage from './pages/SettingsPage'

/**
 * 路由守卫：未登录一律送回登录页，并记下原地址（登录成功后跳回去）。
 * 加载期间先不渲染业务页面，避免"闪一下首页再跳登录"。
 */
function RequireAuth() {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <p className="dim dim--center">正在检查登录状态…</p>
  }
  if (user === null) {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    )
  }
  return <Outlet />
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* 登录页在外壳之外：未登录时不应该看到导航栏 */}
        <Route path="/login" element={<LoginPage />} />

        <Route element={<RequireAuth />}>
          <Route element={<AppShell />}>
            <Route index element={<HomePage />} />
            <Route path="boards/:id" element={<><BoardDrawer /><BoardPageWithBoundary /></>} />
            {/* M6：条目详情页。同一个看板组件，靠 URL 里的 itemId 决定是否滑出 700px 详情面板 */}
            <Route path="boards/:id/pulses/:itemId" element={<><BoardDrawer /><BoardPageWithBoundary /></>} />
            <Route path="settings" element={<SettingsPage />} />
            {/* 未匹配的前端路由回首页（服务端 SPA 回退已保证能拿到 index.html） */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  )
}
